import { IconNames } from '@blueprintjs/icons';
import { Icon } from '@strata/react-status-icons';
import { type ReactNode } from 'react';

interface SpecialMemberHandlingNameProps {
    name: ReactNode;
    tooltip?: string[];
}

/** Member name with optional special-handling flag + tooltip. */
export const SpecialMemberHandlingName = ({
    name,
    tooltip = undefined,
}: SpecialMemberHandlingNameProps) => (
    <span className="flex__gap--x-small" style={{ display: 'inline-flex', alignItems: 'center' }}>
        <span>{name}</span>
        {tooltip && tooltip.length > 0 ? (
            <Icon
                icon={IconNames.FLAG}
                intent={Icon.Intent.WARNING}
                tooltipContent={
                    <>
                        {tooltip.map((msg) => (
                            <div key={msg}>{msg}</div>
                        ))}
                    </>
                }
                title="Special handling"
            />
        ) : null}
    </span>
);
